export const manifestLocales = {
  table: {
    en: 'Table',
    he: 'טבלה'
  }
};
